import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TemplateThumbnail } from '@/components/help_center/TemplateThumbnail'
import type { HelpCenterTemplateKey } from '@/pages/HelpCenter/types'

// Keep in sync with HelpCenterTheme::TEMPLATES (app/presenters/help_center_theme.rb).
const TEMPLATE_OPTIONS: { value: HelpCenterTemplateKey; label: string; blurb: string }[] = [
  { value: 'classic', label: 'Classic', blurb: 'Centred hero, category grid and popular articles.' },
  { value: 'aurora', label: 'Aurora', blurb: 'Vibrant mesh hero with an asymmetric bento of categories.' },
  { value: 'atlas', label: 'Atlas', blurb: 'Docs-style sidebar with the full category tree.' },
]

interface TemplatePickerProps {
  value?: HelpCenterTemplateKey
  primary: string
  accent: string
  onChange: (value: HelpCenterTemplateKey) => void
}

export function TemplatePicker({ value = 'classic', primary, accent, onChange }: TemplatePickerProps) {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
      {TEMPLATE_OPTIONS.map(opt => {
        const selected = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            aria-pressed={selected}
            className={cn(
              'group relative cursor-pointer rounded-lg border bg-card p-2 text-left transition',
              selected ? 'border-primary ring-2 ring-primary/40' : 'border-border hover:border-primary/50',
            )}
          >
            <div className="overflow-hidden rounded-md border border-border">
              <TemplateThumbnail template={opt.value} primary={primary} accent={accent} />
            </div>
            <div className="mt-2 flex items-center gap-1.5">
              <span className="text-sm font-medium">{opt.label}</span>
              {selected && <Check className="size-3.5 text-primary" />}
            </div>
            <p className="mt-0.5 text-xs text-muted-foreground">{opt.blurb}</p>
          </button>
        )
      })}
    </div>
  )
}
